
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/freight-invoice-discounting-india",
      function () {
        return require("private-next-pages/freight-invoice-discounting-india/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/freight-invoice-discounting-india"])
      });
    }
  